export const encodeIntoMetaTag = (name: string, content: string) => {
  const encodedContent = btoa(encodeURIComponent(content));

  return <meta name={name} content={encodedContent} />;
};
